import * as React from "react";
import { SVGProps } from "react";

export const ClockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.166 8A5.167 5.167 0 1 1 2.833 8a5.167 5.167 0 0 1 10.333 0Zm1.5 0A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0ZM7.25 4.667V8.31l.22.22 2 2 1.06-1.06-1.78-1.78V4.666h-1.5Z"
      fill="#6E767D"
    />
  </svg>
);
